/* Web Push helpers */
import api from '@/lib/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function ensureServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  const existing = await navigator.serviceWorker.getRegistration('/sw.js');
  if (existing) return existing;
  return navigator.serviceWorker.register('/sw.js');
}

// Returns the active push subscription for THIS device/browser, or null.
export async function getDeviceSubscription() {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
    const reg = await navigator.serviceWorker.getRegistration('/sw.js');
    if (!reg) return null;
    return await reg.pushManager.getSubscription();
  } catch {
    return null;
  }
}

export async function subscribeWebPush() {
  if (!(await isPushSupported())) throw new Error('Push not supported in this browser');
  const reg = await ensureServiceWorker();
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Notification permission denied');
  const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidKey),
  });
  const json = sub.toJSON();
  await api.post('/webpush/subscribe', { endpoint: json.endpoint, keys: json.keys });
  return json;
}

export async function unsubscribeWebPush() {
  const reg = await navigator.serviceWorker.getRegistration('/sw.js');
  if (reg) {
    const s = await reg.pushManager.getSubscription();
    if (s) await s.unsubscribe();
  }
  await api.delete('/webpush/subscribe');
}
